import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { PersonalDataStateService } from 'src/app/_modules/customers/components/personal-data/services/personal-data-state.service';
import { RegularTab } from 'src/app/_modules/shared/_interfaces/regular-tab';
import { ModalService } from 'src/app/_modules/shared/_services/modal.service';
// import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-agreement-dialog',
  templateUrl: './agreement-dialog.component.html',
  styleUrls: ['./agreement-dialog.component.scss'],
})
export class AgreementDialogComponent implements OnInit {
  // Commented out for the task C230-840
  // desktopTabs: RegularTab[] = [
  //     {
  //         name: 'Consent',
  //         selected: true
  //     },
  //     {
  //         name: 'Condition For Request',
  //         selected: false
  //     },
  //     {
  //         name: 'Further Undertaking',
  //         selected: false
  //     },
  //     {
  //         name: 'Conditions & Regulations of supply',
  //         selected: false
  //     },
  // ];

  // mobileTopTabs: RegularTab[] = [
  //     {
  //         name: 'Consent',
  //         selected: true
  //     },
  //     {
  //         name: 'Condition For Request',
  //         selected: false
  //     },
  // ];
  // mobileBottomTabs: RegularTab[] = [
  //     {
  //         name: 'Further Undertaking',
  //         selected: false
  //     },
  //     {
  //         name: 'Conditions & Regulations of supply',
  //         selected: false
  //     },
  // ];

  // selectedTab: RegularTab = { name: 'Consent', selected: true };
  // isInitialLoad: boolean = true;
  // utilityName: string = '';
  // utilityInfo: any;

  desktopTabs: RegularTab[] = [
    { name: 'Privacy Policy', selected: true },
    { name: 'Terms of Service', selected: false },
    { name: 'Interpretation', selected: false },
    { name: 'Terms & Conditions', selected: false },
  ];

  mobileTopTabs: RegularTab[] = [
    { name: 'Privacy Policy', selected: true },
    { name: 'Terms of Service', selected: false },
  ];
  mobileBottomTabs: RegularTab[] = [
    { name: 'Interpretation', selected: false },
    { name: 'Terms & Conditions', selected: false },
  ];

  selectedTab: RegularTab = { name: 'Privacy Policy', selected: true };
  isInitialLoad: boolean = true;

  @ViewChild('dialog') dialogRef!: ElementRef;
  @HostListener('document:mousedown', ['$event'])
  onOutsideClick(event: any): void {
    if (!this.dialogRef?.nativeElement?.contains(event.target)) {
      this.modalService.closeModal();
    }
  }
  constructor(
    public modalService: ModalService,
    public personalDataStateService: PersonalDataStateService,
    // public utilityService: UtilityService
  ) {}

  ngOnInit(): void {
    // Commented out for the task C230-840
    // this.utilityInfo = this.utilityService.get().subscribe({
    //     next: (response) => {
    //       this.utilityInfo = response.body?.data;
    //
    // }});
  }

  mobileTabSelected(selectedTab: RegularTab) {
    this.selectedTab = selectedTab;
    this.mobileTopTabs.forEach((tab: RegularTab) => {
      tab.selected = selectedTab.name === tab.name ? true : false;
    });

    this.mobileBottomTabs.forEach((tab: RegularTab) => {
      tab.selected = selectedTab.name === tab.name ? true : false;
    });
  }

  openDocument(): void {
    window.open('https://webportal.ekedc.com/assets/ToS_Ekedc.pdf', '_blank');
  }

  agree() {
    if (!this.personalDataStateService.isAgreed) {
      return;
    }
    this.modalService.closeModal();
  }
}
